import React from 'react'
import { Redirect } from 'react-router-dom'

import { GCP_BUCKET } from './enums'
import styles from './Post.module.css'
import postData from './postData'

export default props => {
  const post = postData.find(post => props.match.params.slug === post.slug)

  if (!post) {
    return <Redirect to="/" />
  }

  return (
    <div className={styles['post-container']}>
      <h1 className={styles['post-title']}>{post.title}</h1>
      <p className="post-description" dangerouslySetInnerHTML={post.description} />
      {post.images &&
        post.images.map((img, idx) => {
          const isNonRelativeLink = img.lg.includes('http')
          return (
            <a href={isNonRelativeLink ? img.lg : `${GCP_BUCKET}${img.lg}`} target="_blank" rel="noopener noreferrer">
              <img key={idx} className={styles.img} src={`${GCP_BUCKET}${img.md}`} alt="post-img" />
            </a>
          )
        })}
      {post.videos &&
        post.videos.map((video, idx) => (
          <div key={idx} className={styles['iframe-container']}>
            <iframe
              src={video.iframeSrc}
              frameBorder="0"
              allowFullScreen
              className={styles.iframe}
              title={post.title}
            />
          </div>
        ))}
    </div>
  )
}
